import { protectedApi } from "../common/protectedApi";
import { APIS } from "../constants/apiConstant";
import { COMPANY_PROFILES_UPDATED_EVENT } from "../company/companyProfilesStorage";

const resolveSignatureForSave = (form = {}) => {
  const dataUrl = String(form.signatureDataUrl || "").trim();
  const httpsUrl = String(form.signatureUrl || "").trim();
  if (dataUrl.startsWith("data:image/")) return dataUrl;
  if (httpsUrl.startsWith("http://") || httpsUrl.startsWith("https://")) return httpsUrl;
  return dataUrl || httpsUrl || null;
};

export const mapCompanyProfileFromApi = (row) => {
  if (!row) return null;
  const signatureDataUrl = row.signatureDataUrl || row.signatureUrl || "";
  return {
    id: row.id,
    companyName: row.companyName || "",
    ownerName: row.ownerName || "",
    gstNumber: row.gstNumber || "",
    panNumber: row.panNumber || "",
    hsnCode: row.hsnCode || "",
    contactNumber: row.contactNumber || "",
    emailId: row.emailId || "",
    companyAddress: row.companyAddress || "",
    bankName: row.bankName || "",
    accountHolderName: row.accountHolderName || "",
    accountNumber: row.accountNumber || "",
    ifscCode: row.ifscCode || "",
    branchName: row.branchName || "",
    signatureFileName: row.signatureFileName || "",
    signatureDataUrl,
    createdAt: row.createdAt,
    updatedAt: row.updatedAt,
  };
};

const dispatchUpdated = () => {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(COMPANY_PROFILES_UPDATED_EVENT));
  }
};

const buildPayload = (form) => ({
  companyName: form.companyName,
  ownerName: form.ownerName,
  gstNumber: form.gstNumber,
  panNumber: form.panNumber,
  hsnCode: form.hsnCode,
  contactNumber: form.contactNumber,
  emailId: form.emailId,
  companyAddress: form.companyAddress,
  bankName: form.bankName,
  accountHolderName: form.accountHolderName,
  accountNumber: form.accountNumber,
  ifscCode: form.ifscCode,
  branchName: form.branchName,
  signatureDataUrl: resolveSignatureForSave(form),
  signatureFileName: form.signatureFileName || null,
});

export const fetchCompanyProfiles = async () => {
  const response = await protectedApi({ url: APIS.COMPANY_DETAILS, method: "GET" });
  const companies = response?.data?.data?.companies || [];
  return companies.map(mapCompanyProfileFromApi).filter(Boolean);
};

export const createCompanyProfileApi = async (form) => {
  const response = await protectedApi({
    url: APIS.COMPANY_DETAILS,
    method: "POST",
    data: buildPayload(form),
  });
  const company = mapCompanyProfileFromApi(response?.data?.data?.company);
  dispatchUpdated();
  return company;
};

export const updateCompanyProfileApi = async (companyId, form) => {
  const url = APIS.COMPANY_DETAILS_BY_ID.replace(":companyId", String(companyId));
  const response = await protectedApi({
    url,
    method: "PUT",
    data: buildPayload(form),
  });
  const company = mapCompanyProfileFromApi(response?.data?.data?.company);
  dispatchUpdated();
  return company;
};

export const deleteCompanyProfileApi = async (companyId) => {
  const url = APIS.COMPANY_DETAILS_BY_ID.replace(":companyId", String(companyId));
  await protectedApi({ url, method: "DELETE" });
  dispatchUpdated();
};
